// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__ssQj7","remove":"styles_remove__TT3jx","bad":"styles_bad__cnbIU","name":"styles_name__pFhcW"};